import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';

// Models
import { CasesActionTypes } from 'app/modules/casesOld/models';
import { ShortCaseResponse } from 'app/modules/cases/responses';

export const retrieveCase = (payload: number) =>
  createAction(CasesActionTypes.RETRIEVE_CASE, payload);

export const retrieveCaseSuccess = (result) =>
  createAction(CasesActionTypes.RETRIEVE_CASE_SUCCESS, result);

export const editCaseSuccess = (payload: ShortCaseResponse) =>
  createAction(CasesActionTypes.EDIT_CASE_SUCCESS, payload);

export const addDocumentsSuccess = (result) =>
  createAction(CasesActionTypes.ADD_DOCUMENTS_SUCCESS, result);

export const deleteDocumentSuccess = (result) =>
  createAction(CasesActionTypes.DELETE_DOCUMENT_SUCCESS, result);

export const uploadS3FilesSuccess = (payload) =>
  createAction(CasesActionTypes.UPLOAD_FILES_SUCCESS, payload);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CasesActionsList = {
  retrieveCase,
  retrieveCaseSuccess,
  editCaseSuccess,
  addDocumentsSuccess,
  deleteDocumentSuccess,
  uploadS3FilesSuccess,
};
type CasesActions = ActionsUnion<typeof CasesActionsList>;

export default CasesActions;
